module.exports = require('debug')('aktemp-utils')